//
// Labels used in this file:
//
// @ASSUMPTION  - an assumption that is relied upon to work
// @BUG         - bug, or likely bug exists here
// @DEBUG       - in place for debug purposes
// @HACK        - hacky code follows
// @IMPLEMENT   - needs to be written
// @IMPROVE     - business logic could be added to, or improved
// @NB          - context to help understanding
// @OPTIMISE    - could be optimised
// @PERFORMANCE - performance bottleneck here
// @SECURITY    - potential security issue
// @TEMP        - should be deleted
// @TO DO       - needs attention
// @REFACTOR    - should be reworked
// @ROBUSTNESS  - brittle, should be improved
// @URGENT      - needs looking at urgently
//

import {writable} from 'svelte/store'


const nullUser = () => {
    return {
        id: null,
        provider: null,
        provider_id: null,
        username: null,
        email: null,
        image: null,
        role: null,
        logged_in: false,
    }
};
export const user = writable(nullUser());
export const fetching_user = writable(false);

let $user = null;
const unsubscribe = user.subscribe(val => $user = val);

export const refreshUser = async () => {
    console.log('Refreshing user');
    fetching_user.set(true);
    let response = await fetch(`/api/user`);
    let result = await response.json();
    user.update(user => {
        user = result;
        return user;
    });
    fetching_user.set(false);
};
refreshUser(); // does this get called? Yes!

export const registerUser = async () => {
    console.log('Registering user');
    fetching_user.set(true);
    let response = await fetch(`/api/register`);
    let result = await response.json();
    user.update(user => {
        user = result;
        return user;
    });
    fetching_user.set(false);
};